import { useUserStore } from '@/stores/modules/user';

export function compareVersion(oldVersion) {
  const userStore = useUserStore();
  let localVersion = userStore.commonData.softwareBuild;
  console.log(localVersion, 'localVersion');

  const oldArr = String(oldVersion)?.split('.');
  const localArr = String(localVersion)?.split('.');
  oldArr?.forEach((item, index) => {
    if (Number(item) < 10) {
      item = '0' + item;
      oldArr[index] = item;
    }
  });
  oldVersion = oldArr?.join('');
  localArr?.forEach((item, index) => {
    if (Number(item) < 10) {
      item = '0' + item;
      localArr[index] = item;
    }
  });
  localVersion = localArr?.join('');
  return Number(localVersion) - Number(oldVersion) > 0;
}
